import type { GalleryResponse } from '@moltable/shared';

const API_URL = 'https://api.moltable.dev';

export async function fetchGallery(cursor?: string): Promise<GalleryResponse> {
  const url = new URL('/api/gallery', API_URL);
  if (cursor) {
    url.searchParams.set('cursor', cursor);
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch gallery: ${response.status}`);
  }

  return response.json();
}
